<template>
  <el-row class="review-form">
    <span style="margin: 0 20px 0 30px">复核:</span>
    <span>分类</span>
    <el-select v-model="reviewData.signType" filterable clearable placeholder="请选择">
      <el-option v-for="item in signTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
    </el-select>
    <span>用户rid</span>
    <el-input v-model="reviewData.rid" type="number" placeholder="请输入rid" style="width: 300px"></el-input>
    <el-button style="margin-left: 20px" @click="handleReview">复核</el-button>
  </el-row>
</template>

<script>
export default {
  name: 'ReviewForm',
  props: {
    signTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      reviewData: {
        rid: null,
        signType: null,
        debug: true,
      }
    }
  },
  methods: {
    handleReview() {
      this.$emit('review', this.reviewData)
    },
    resetReview() {
      this.reviewData = {
        rid: null,
        signType: null,
        debug: true,
      }
    }
  }
}
</script>

<style scoped lang="scss">
.review-form {
  span {
    font-size: 20px;
    font-weight: 600;
    margin-right: 15px;
    margin-left: 15px;
  }
}
</style> 